import type { StoreType } from '.';

export const selectCoursesPublishers = (state: StoreType) => {
	if (!state.publishers.data) {
		return [];
	}

	return state.publishers.data.filter((publisher) => publisher.scope?.includes('courses') ?? true);
};

export const selectDocumentsPublishers = (state: StoreType) => {
	if (!state.publishers.data) {
		return [];
	}

	return state.publishers.data.filter((publisher) => publisher.scope?.includes('documents') ?? true);
};

export const selectPublisherLoadingStatus = (state: StoreType) => state.publishers.status;
